module.exports = __webpack_public_path__ + "img/AbdulqadirSaed-WeranaMal.10e18b77.jpg";